import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.Reports.helpers.mapReportList', {
    netSuiteVendorBillItemLine: 'Bill Item Line',
    netSuiteVendorBillExpenseLine: 'Bill Expense Line',
});
